<template>
  <div class="section1">
    <Header
      style="background: linear-gradient(135deg, #62B4D9 0%, #29708E 100%);"
    ></Header>
    <div class="content">
      <div class="title">
        平凡的你我，一样的通友
      </div>
      <div class="body">
        给大家奉献一款极致用户体验的通友自产的即时通信软件,今天正式发布
        通友支持跨通信运营商，跨手机操作系统平台运行，可以通过通讯录向联繫人像拨普通手机号一样免费拨打音频和视频电话，发送免费短语音，面向全球80％国家和地区不同语言进行免费的智能翻译服务。同时，也可以向好友发送语音，视频，图片，各种文件，表情和文字。此外，还可以通过“我的日记与运动”拍照记录生活，上传文字，图片与好友们分享自己的近况。
        通友自主研发的一款能够真正全球免费智能聊天的即时通讯软件。与其他通信应用程序不同的是通友独特的免费网络电话功能，高清聊天语音，每人人手一号。无论漫游到哪个国家，只要有互联网，不需要改号，你的家人和朋友可用同样的通友号码随时地免费可以跟您相互联繫.2U集成多语言文字和语音翻译系统功能，可以跟世界各国的朋友使用您自己的母语进行沟通。让世界不再广大，沟通随心所欲。
        商业应用方面，通友自创了电子名片功能，名片编辑简单根据需要随时可以重新编辑，摇一摇就可派送给对方。被免商务人士忘记带名片的尴尬，也被免手动将名片输入手机通讯录的繁琐。
        除此之外，通友开创性的将人工智能纳入体系。内置智能物联网系统，智能门锁，智能暖通，智能能源系统将陆续纳入其轨道。万物互联的时代会在通友中完美融合，我们翘首以待！
        通友支持Wi-Fi，2G，3G
        4G和5G数据网络，目前支持iOS，安卓手机系统版本，网页版本也将在今年10月份发布，通友团队将不断努力，将通友打造成一款人与人之间，人与人工智能之间结密切接合的全球首款智能即时通讯软件。<br />
        <br />
        <br />
        联系我们：0571-88687921
        <br />
        <br />
        联系邮箱：register@2uchat.cn
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../Header";

export default {
  components: {
    Header
  }
};
</script>

<style lang="scss" scoped>
.section1 {
  position: relative;
  height: 5.4rem;
  background: #fff;
  background-size: 100% 100%;
  .content {
    background: #f0f2f3;
    width: 50%;
    height: 80%;
    margin-top: 0.2rem;
    .title {
      font-size: 0.18rem;
      color: #333;
      position: relative;
      top: 0.3rem;
      left: 10%;
      width: 80%;
    }
    .body {
      font-size: 0.1rem;
      color: #333;
      position: relative;
      top: 0.6rem;
      left: 10%;
      width: 80%;
    }
  }
}
</style>
